import React from 'react';
import TextWinds from '../../common/TextWinds';

/** 반 기능 안내 섹션 */
export const ClassGroupDescriptionSection = () => {
  return (
    <div className="rounded bg-purple0 p-3">
      <TextWinds type="content_body3" color="purple5" className="mb-1">
        반 기능 안내
      </TextWinds>
      <ul className="ml-4 list-disc space-y-1 text-xs font-normal text-purple5">
        <li>
          <span className="font-bold">반</span>은 수업 운영을 편리하게 돕는 선택
          기능이에요.
        </li>
        <li>
          반을 이용하면 과제를 <span className="font-bold">반 단위</span>로
          내주고 관리할 수 있어요.
        </li>
        <li>
          학생은 <span className="font-bold">하나의 반</span>에만 배정할 수
          있어요.
        </li>
      </ul>
    </div>
  );
};
